/* TODO: t() */
import { Component } from 'react';
import autobind from 'class-autobind';
import Leaflet, { Map as LeafletMap, Overlay as LeafletOverlay } from 'leaflet';

type Props = {
  itemKey: string;
  url: string;
  width: number;
  height: number;
};

export type OverlayModifier = {
  update: (el: ReactElement) => void;
  destroy: () => void;
};

export default class Overlay extends Component<Props> {
  constructor(props: Props) {
    super(props);
    autobind(this);
  }

  static addToMap(reactEl: ReactElement, map: LeafletMap): OverlayModifier {
    let { url, width, height } = reactEl.props;
    // center the overlay over [0 0]
    let getBounds = (w: number, h: number) => {
      let xOffset = w / 2;
      let yOffset = h / 2;
      return Leaflet.latLngBounds([yOffset, -xOffset], [-yOffset, xOffset]);
    };
    let overlay: LeafletOverlay = Leaflet.imageOverlay(
      url,
      getBounds(width, height),
    );
    overlay.addTo(map);
    return {
      update(newReactEl) {
        let oldProps = reactEl.props;
        let newProps = newReactEl.props;
        if (oldProps.url !== newProps.url) {
          overlay.setUrl(newProps.url);
        }
        if (
          oldProps.width !== newProps.width ||
          oldProps.height !== newProps.height
        ) {
          overlay.setBounds(getBounds(newProps.width, newProps.height));
        }
        reactEl = newReactEl;
      },
      destroy() {
        map.removeLayer(overlay);
      },
    };
  }

  render(): React.ReactNode {
    return null;
  }
}
